import React, { MouseEventHandler, useCallback } from 'react'
import { getStepConfig } from '../../step-config'
import { CloseCircleFilled } from '@ant-design/icons'
import { getClassNames } from '../../../../_utils/classnames'
import { useJourneyContext } from '../../context'
import { preventAll } from '../../../../_utils/utils'
import type { IJourneyStep } from '@pushly/models/lib/structs/journeys'
import { JourneyAction } from '../../types/journey-context'
import { StepType } from '@pushly/models/lib/enums/journeys'
import { JourneyBuilderMode } from '../../enums'

export const JourneyNodeIcon = ({ id, node }: { id: string; node: IJourneyStep }) => {
    const [state, dispatch] = useJourneyContext()
    const nodes = Array.isArray(state.nodes) ? state.nodes : []
    const icon = getStepConfig(node)?.icon

    const handleRemoveNode: MouseEventHandler<HTMLSpanElement> = useCallback(
        (ev) => {
            preventAll(ev)

            const nodeToRemove = nodes.find((n) => n.id === id)
            if (!nodeToRemove) return
            dispatch({ action: JourneyAction.ON_NODE_REMOVE, data: nodeToRemove })
        },
        [id, nodes, dispatch],
    )

    return (
        <div
            className={getClassNames(null, 'icon', {
                readonly: state.mode === JourneyBuilderMode.READONLY,
            })}
        >
            {node.type !== StepType.TRIGGER && node.type !== StepType.EXIT && (
                <CloseCircleFilled className="journey-node-removal-button" onClick={handleRemoveNode} />
            )}
            <span
                className={getClassNames(null, 'journey-node-icon', {
                    'no-action': [StepType.TRIGGER, StepType.EXIT].includes(node.type),
                })}
            >
                {icon}
            </span>
        </div>
    )
}
